export enum CAMPAIGNS_URLS {
  CAMPAIGN = '/campaign',
  CAMPAIGN_BY_ID = '/campaign/:id',
  CAMPAIGN_PUBLIC_BY_CODE = '/api/v1/campaigns/:code/public',
  CAMPAIGN_TOGGLE_ON_SALE = `/campaign/:id/onSale`,
  CAMPAIGN_BY_ID_TYPE = '/campaign/:id/:type',
  CAMPAIGN_LIST_BY_PROFILE_ID = `/identity/:id/campaigns/?limit=:limit&offset=:offset`,
  ACTIVE_CAMPAIGN_ID_NAME_LIST_BY_PROFILE_ID = '/identity/:id/campaigns/filter',
  CAMPAIGNS_FOR_SELECT = '/campaign/select',
  CAMPAIGN_GENERATE_CODE_PASSWORD = `/campaign/:id/codeValidatorPassword/generate`,
  CAMPAIGN_GET_CODE = '/campaign/tokedId/generate',
}
